import request from './request';
import deserialize from './deserialize';

export type User = {
  id: string;
  createdAt: number;
  dob: number;
  email: string;
  firstName: string;
  lastName: string;
  gender: string;
  kycStatus: string;
  referralCode: string;
  status: string;
  mobNum: string;
};

export function findUser(companyId: string, email: string, mobNum: string) {
  let url = `companion/v1/companies/${companyId}/user`;

  return request<User>({
    url,
    method: 'POST',
    data: {
      data: {
        attributes: {
          email,
          mobNum,
        },
      },
    },
    transformResponse: deserialize,
  });
}

export function findUsers(
  companyId: string,
  firstName: string,
  lastName: string
) {
  let url = `companion/v1/companies/${companyId}/users`;

  return request<User[]>({
    url,
    method: 'POST',
    data: {
      data: {
        attributes: {
          firstName,
          lastName,
        },
      },
    },
    transformResponse: deserialize,
  });
}

interface UpdateMobileAttrs {
  companyId: string;
  mobNum: string;
  userID: string;
}

export function updateUserMobile(attrs: UpdateMobileAttrs) {
  const { companyId, mobNum, userID } = attrs;

  return request<User>({
    url: `/companion/v1/companies/${companyId}/users/${userID}/profile/full`,
    method: 'PATCH',
    data: {
      data: {
        attributes: {
          mobNum,
        },
      },
    },
    transformResponse: deserialize,
  });
}

interface UpdateEmailAttrs {
  companyId: string;
  email: string;
  userID: string;
}

export function updateUserEmail(attrs: UpdateEmailAttrs) {
  const { companyId, email, userID } = attrs;

  return request<User>({
    url: `/companion/v1/companies/${companyId}/users/${userID}/profile/full`,
    method: 'PATCH',
    data: {
      data: {
        attributes: {
          email,
        },
      },
    },
    transformResponse: deserialize,
  });
}

interface UpdateAltEmailAttrs {
  companyId: string;
  altEmail: string;
  userID: string;
}

export function updateAltUserEmail(attrs: UpdateAltEmailAttrs) {
  const { companyId, altEmail, userID } = attrs;

  return request<User>({
    url: `/companion/v1/companies/${companyId}/users/${userID}/profile/full`,
    method: 'PATCH',
    data: {
      data: {
        attributes: {
          altEmail,
        },
      },
    },
    transformResponse: deserialize,
  });
}

interface UpdateDOBAttrs {
  companyId: string;
  dob: string;
  userID: string;
}

export function updateUserDOB(attrs: UpdateDOBAttrs) {
  const { companyId, dob, userID } = attrs;

  return request<User>({
    url: `/companion/v1/companies/${companyId}/users/${userID}/profile/partial`,
    method: 'PATCH',
    data: {
      data: {
        attributes: {
          dob,
        },
      },
    },
    transformResponse: deserialize,
  });
}

interface UpdateNameAttrs {
  companyId: string;
  firstName: string;
  lastName: string;
  userID: string;
}

export function updateUserName(attrs: UpdateNameAttrs) {
  const { companyId, firstName, lastName, userID } = attrs;

  return request<User>({
    url: `/companion/v1/companies/${companyId}/users/${userID}/profile/partial`,
    method: 'PATCH',
    data: {
      data: {
        attributes: {
          firstName,
          lastName,
        },
      },
    },
    transformResponse: deserialize,
  });
}
